






















































































































// SOLUCIÓN COMPLETA - Reemplaza la sección del script en FeedbackInvoicesPDV.vue:

import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import moment from 'moment-timezone';
import VueMonthlyPicker from 'vue-monthly-picker';
import { Spinner } from 'vue-image-spinner2';
import FeedbackInvoicePDVModal from '../modals/FeedbackInvoicePDVModal.vue';
import EmailFeedbackPDVModal from '../modals/EmailFeedbackPDVModal.vue';


@Component({
  name: 'feedback-invoices-pdv',
  components: {
    VueMonthlyPicker,
    Spinner,
    'email-feedback-pdv-modal' :EmailFeedbackPDVModal,
    'feedback-invoice-pdv-modal': FeedbackInvoicePDVModal  // ✅ Registrado correctamente (sin guiones)
  },
  filters: {
    date(val: any) {
      return val == null ? 'Rango de fecha' : moment(val).format('YYYY/MM/DD');
    },
  },
  computed: {
    ...mapState('feedbackInvoicesPDV', [
      'allFeedbackInvoicesPDV',
      'allFeedbackInvoicesPDVLoading',
      'invoiceFeedbacksPDVPerPage',
      'invoiceFeedbacksPDVPage',
      'invoiceFeedbacksPDVTotal',
      'activeFeedbackInvoicePDV',
      'activeFeedbackInvoicePDVLoading'
    ]),
    ...mapState('feedbackInvoicesPDV', {
            activeFeedbackInvoicePDV: (state: any) => {
                let activeFeedbackInvoicePDV = state.activeFeedbackInvoicePDV;
                // ####### START Formatting cfdi 
                switch (activeFeedbackInvoicePDV.invoice_data.cfdi) {
                    case 'G01':
                        activeFeedbackInvoicePDV.invoice_data.cfdi = activeFeedbackInvoicePDV.invoice_data.cfdi + ' - Adquisición de mercancías';
                        break;
                    case 'G03':
                        activeFeedbackInvoicePDV.invoice_data.cfdi = activeFeedbackInvoicePDV.invoice_data.cfdi + ' - Gastos en general';
                        break;
                    case 'I01':
                        activeFeedbackInvoicePDV.invoice_data.cfdi = activeFeedbackInvoicePDV.invoice_data.cfdi + ' - Construcciones';
                        break;
                    case 'I08':
                        activeFeedbackInvoicePDV.invoice_data.cfdi = activeFeedbackInvoicePDV.invoice_data.cfdi + ' - Otra maquinaria y equipo';
                        break;
                    case 'S01':
                        activeFeedbackInvoicePDV.invoice_data.cfdi = activeFeedbackInvoicePDV.invoice_data.cfdi + ' - Sin efectos fiscales';
                        break;
                    default:
                        activeFeedbackInvoicePDV.invoice_data.cfdi = activeFeedbackInvoicePDV.invoice_data.cfdi + ' Checar cfdi';
                        break;
                }
                // ####### END Formatting cfdi

                // ####### START Formatting payment way
                switch (activeFeedbackInvoicePDV.invoice_data.way_payment) {
                    case '01':
                        activeFeedbackInvoicePDV.invoice_data.way_payment = activeFeedbackInvoicePDV.invoice_data.way_payment + ' - Efectivo';
                        break;
                    case '02':
                        activeFeedbackInvoicePDV.invoice_data.way_payment = activeFeedbackInvoicePDV.invoice_data.way_payment + ' - Cheque nominativo';
                        break;
                    case '03':
                        activeFeedbackInvoicePDV.invoice_data.way_payment =
                            activeFeedbackInvoicePDV.invoice_data.way_payment + ' - Transferencia electrónica de fondos';
                        break;
                    case '04':
                        activeFeedbackInvoicePDV.invoice_data.way_payment = activeFeedbackInvoicePDV.invoice_data.way_payment + ' - Tarjeta de crédito';
                        break;
                    case '28':
                        activeFeedbackInvoicePDV.invoice_data.way_payment = activeFeedbackInvoicePDV.invoice_data.way_payment + ' - Tarjeta de débito';
                        break;
                    case '31':
                        activeFeedbackInvoicePDV.invoice_data.way_payment = activeFeedbackInvoicePDV.invoice_data.way_payment + ' - Intermediario pagos';
                        break;
                    default:
                        activeFeedbackInvoicePDV.invoice_data.way_payment = activeFeedbackInvoicePDV.invoice_data.way_payment + ' Checar método de pago';
                        break;
                }
                // ####### END Formatting payment way

                // ####### START Formatting payment method
                switch (activeFeedbackInvoicePDV.invoice_data.payment_method) {
                    case 'PUE':
                        activeFeedbackInvoicePDV.invoice_data.payment_method =
                            activeFeedbackInvoicePDV.invoice_data.payment_method + ' - Pago en una sola exhibición';
                        break;
                    default:
                        activeFeedbackInvoicePDV.invoice_data.payment_method =
                            activeFeedbackInvoicePDV.invoice_data.payment_method + ' Checar método de pago';
                        break;
                }
                // ####### END Formatting payment method

                // ####### START Formatting tax regime
                switch (activeFeedbackInvoicePDV.invoice_data.tax_regime) {
                    case '612':
                        activeFeedbackInvoicePDV.invoice_data.tax_regime =
                            activeFeedbackInvoicePDV.invoice_data.tax_regime + ' - Personas Físicas con Actividades Empresariales y Profesionales';
                        break;
                    case '616':
                        activeFeedbackInvoicePDV.invoice_data.tax_regime =
                            activeFeedbackInvoicePDV.invoice_data.tax_regime + ' - Sin obligaciones fiscales';
                        break;
                    case '621':
                        activeFeedbackInvoicePDV.invoice_data.tax_regime = activeFeedbackInvoicePDV.invoice_data.tax_regime + ' - Incorporación Fiscal';
                        break;
                    case '625':
                        activeFeedbackInvoicePDV.invoice_data.tax_regime =
                            activeFeedbackInvoicePDV.invoice_data.tax_regime +
                            ' - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas';
                        break;
                    case '626':
                        activeFeedbackInvoicePDV.invoice_data.tax_regime =
                            activeFeedbackInvoicePDV.invoice_data.tax_regime + ' - Régimen Simplificado de Confianza';
                        break;
                    case '601':
                        activeFeedbackInvoicePDV.invoice_data.tax_regime =
                            activeFeedbackInvoicePDV.invoice_data.tax_regime + ' - General de Ley Personas Morales';
                        break;
                    case '603':
                        activeFeedbackInvoicePDV.invoice_data.tax_regime =
                            activeFeedbackInvoicePDV.invoice_data.tax_regime + ' - Personas Morales con Fines no Lucrativos';
                        break;
                    case '622':
                        activeFeedbackInvoicePDV.invoice_data.tax_regime =
                            activeFeedbackInvoicePDV.invoice_data.tax_regime + ' - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras';
                        break;
                    case '626':
                        activeFeedbackInvoicePDV.invoice_data.tax_regime =
                            activeFeedbackInvoicePDV.invoice_data.tax_regime + ' - Régimen Simplificado de Confianza';
                        break;
                    default:
                        activeFeedbackInvoicePDV.invoice_data.tax_regime = activeFeedbackInvoicePDV.invoice_data.tax_regime + ' Checar régimen fiscal';
                        break;
                }
                // ####### END Formatting tax regime

                activeFeedbackInvoicePDV.invoice_data.colony = activeFeedbackInvoicePDV.invoice_data.colony
                    ? activeFeedbackInvoicePDV.invoice_data.colony
                    : 'Sin datos';
                activeFeedbackInvoicePDV.invoice_data.phone = activeFeedbackInvoicePDV.invoice_data.phone
                    ? activeFeedbackInvoicePDV.invoice_data.phone
                    : 'Sin datos';
                return activeFeedbackInvoicePDV;
            },
        }),
  },
})
export default class FeedbackInvoicesPDVModal extends Vue {
  public allFeedbackInvoicesPDV!: any[];
  public allFeedbackInvoicesPDVLoading!: boolean;
  public invoiceFeedbacksPDVPerPage!: number;
  public invoiceFeedbacksPDVPage!: number;
  public invoiceFeedbacksPDVTotal!: number;
  public activeFeedbackInvoicePDV!: any;
  public activeFeedbackInvoicePDVLoading!: any;


  public invoice_feedbackPDV_word_search: string = '';
  public dateRange: any = { startDate: null, endDate: null };
  public singleDatePicker: any = 'range';
  public allFeedbackInvoicesPDVHeaders = [
    { thClass: 'th', key: 'pdv_order', label: 'Venta' },
    { thClass: 'th', key: 'date_created', label: 'Fecha' },
    { thClass: 'th', key: 'status', label: 'Estatus' },
    { thClass: 'th', key: 'edit', label: '' },
  ];
  errorMessages = {
        'CFDI40148': 'Los datos no coinciden.',
        'CFDI40145': 'Los datos no coinciden.',
        'CFDI40161': 'Datos no válidos.',
        'CFDI40143': 'El RFC no está registrado en el SAT.',
        'CFDI40106': 'El certificado no está firmado por el SAT.',
        'CFDI40999': 'Datos incompletos.',
        'CFDI40149': 'Los datos no coinciden.',
        'El sello del emisor es inválido': 'Los datos no son válidos.',
        'El certificado no está autorizado por el SAT': 'Certificado no autorizado.',
        'El XML no cumple con el estandar del SAT: Falta el atributo Rfc necesario.': 'XML incorrecto.',
        'No se puede resolver el nombre remoto': 'Ha ocurrido un error.',
        'No es posible conectar con el servidor remoto': 'Ha ocurrido un error interno.',
    };

  setUrlSearch(search: string) {
    search = search.trim();
    this.$router.push({
      path: 'feedback-invoices-pdv',
      query: { ...this.$route.query, search },
    });
  }

  onPageChange(page: number) {
    this.$router.push({
      path: 'feedback-invoices-pdv',
      query: { ...this.$route.query, page: page.toString() }
    })
  }

  simpleMessageError(errorText) {
        for (const [key, message] of Object.entries(this.errorMessages)) {
            if (errorText.includes(key)) {
                return message;
            }
        }
        return 'Error desconocido.';
    }

//   onFilterDateRange() {
//     const start_date = moment(this.dateRange.startDate).format('YYYY/MM/DD');
//     const end_date = moment(this.dateRange.endDate).add(1, 'd').format('YYYY/MM/DD');
//     this.$router.push({
//       path: 'feedback-invoices-pdv',
//       query: { ...this.$route.query, start_date, end_date },
//     });
//   }

  clearFilters() {
    this.invoice_feedbackPDV_word_search = '';
    this.dateRange = { startDate: null, endDate: null };
    this.$router.push({ path: 'feedback-invoices-pdv', query: {} });
  }

  onGenerateDocs(id: any) {
        // this.activeFeedbackInvoicePDV = this.activeFeedbackInvoicePDV;
        this.$bvModal.show('email-feedback-pdv-modal');
    }

  @Watch('$route')
  getAllInvoices() {
    const page = this.$route.query.page || 1;
    const search = this.$route.query.search || null;
    const status_filter = this.$route.query.status_filter || null;
    const start_date = this.$route.query.start_date || null;
    const end_date = this.$route.query.end_date || null;

    this.$store.dispatch('feedbackInvoicesPDV/getAll', {
      page,
      search,
      status_filter,
      start_date,
      end_date,
    });
  }

  mounted() {
    this.getAllInvoices();
  }
}
